import { connect, ConnectedProps } from "react-redux";
import { withRouter } from "react-router";
import { IStoreState } from "../../../../reducers/types";
import {
  populateTripQueryParams,
  setSelectedFlight,
  setSelectedHotel,
  setSelectedCar,
  setSelectedWatch,
  getDetailsWatch,
} from "../../../TripsList/actions/actions";
import { ItineraryList } from "./ItineraryList";
import {
  getAirlinesMap,
  getAirportMap,
  itinerariesToDisplaySelector,
  getSelectedFlight,
  getSelectedHotel,
  getSelectedCar,
  getSelectedWatch,
  getWatchContext,
} from "../../../TripsList/reducer";

const mapStateToProps = (state: IStoreState) => ({
  airlineMap: getAirlinesMap(state),
  airportMap: getAirportMap(state),
  selectedFlight: getSelectedFlight(state),
  selectedHotel: getSelectedHotel(state),
  selectedCar: getSelectedCar(state),
  selectedWatch: getSelectedWatch(state),
  itinerariesToDisplay: itinerariesToDisplaySelector(state),
  tripContext: getWatchContext(state),
});

const mapDispatchToProps = {
  populateTripQueryParams,
  setSelectedFlight,
  setSelectedHotel,
  setSelectedCar,
  setSelectedWatch,
  getDetailsWatch,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type ItineraryListConnectorProps = ConnectedProps<typeof connector>;

export const ConnectedItineraryList = connector(withRouter(ItineraryList));
